import _ from 'lodash'
import { pointers } from '@wix/thunderbolt-becky-types'
import {
	PRESET_RESOLVING_DATA_ITEM_TYPE,
	RESOLVED_REFS_NAMESPACE,
	SITE_NAMESPACE,
	TRANSFORMATION_INFLATED_MAP,
} from '../../../constants'
import { resolveOverrideItem } from '../../dataConsumption'
import { getInflatedDataItemsMap } from '../../presetsResolving'
import type { DataRefsForPresetResolving } from '../../types'
import type { DependenciesData } from './types'
import { createConsumptionDataNode, getDataRefsForPresetResolving } from './utils/dataNodeUtils'

export const TransformationData = createConsumptionDataNode<
	DependenciesData,
	DataRefsForPresetResolving,
	DataRefsForPresetResolving
>({
	getDependencies: getDataRefsForPresetResolving,
	updateDependencies: ({ update, inflatedComponent, dependencies }) => {
		update(
			RESOLVED_REFS_NAMESPACE,
			TRANSFORMATION_INFLATED_MAP,
			inflatedComponent.transformationQuery,
			dependencies,
			dependencies
		)
	},
	toViewItem: ({ id, value, rawModel }) => {
		const { refArraysWithOverrides } = value
		const templateDataItem = _.last(refArraysWithOverrides)
		if (!templateDataItem) {
			return
		}

		if (templateDataItem.type !== 'RefArray') {
			return { [id]: resolveOverrideItem(refArraysWithOverrides, id) }
		}

		const pageVariants = _.get(rawModel, [SITE_NAMESPACE, pointers.data.DATA_MAPS.VARIANTS], {})
		return getInflatedDataItemsMap(
			value,
			id,
			pageVariants,
			PRESET_RESOLVING_DATA_ITEM_TYPE[pointers.data.DATA_MAPS.TRANSFORMATIONS]
		)
	},
})
